<template>
  <div class="rotate" :class="direction + ' ' + locale"></div>
</template>

<script>
/**
 * 强制用户旋转手机组件
 */
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'RotatePhone',
  props: {
    direction: { // 转屏方向 landscape portrait
      type: String,
      default: 'landscape'
    }
  },
  setup() {
    const { locale } = useI18n()
    return {
      locale
    }
  }
})
</script>

<style lang="less" scoped>
@import url('./style.less');
</style>
